export const countries = [
  {
    slug: "malaysia",
    name: "Malaysia",
    arabic: "ماليزيا",
    flag: "🇲🇾",
    capital: "Kuala Lumpur",
    region: "Asia",
    coords: [101.7, 3.1],
    tagline: "The softest landing in the Muslim world",
    image: "https://images.unsplash.com/photo-1593789135964-b3ddb924dcc7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxrdWFsYSUyMGx1bXB1ciUyMG1vc3F1ZXxlbnwwfHx8fDE3ODg3OTQ1MDZ8MA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Sultan Salahuddin Abdul Aziz Mosque in Shah Alam, Malaysia",
    quickFacts: {
      currency: "Malaysian Ringgit (MYR)",
      timezone: "GMT+8",
      language: "Malay + wide English",
      muslimPercent: "~63%",
      flightTime: "~20 hrs from NYC",
      climate: "Tropical, 77–90°F year-round",
    },
    visa: {
      tourist: "US citizens get 90 days visa-free on arrival. No paperwork, no fee — just a passport valid 6+ months.",
      longStay: "The DE Rantau digital nomad pass (~$1,000/yr income requirement tiers) lets remote workers stay 3–12 months, renewable. MM2H is the premium long-term residency program but requires significant fixed deposits.",
      student: "Student visas for parents studying Islamic sciences or kids enrolled in international schools (an 'Education Pass' covers dependents).",
      work: "Employment passes are employer-sponsored; realistically most American moms arrive on nomad, student, or repeated tourist entries.",
      summary: "One of the easiest Muslim countries for Americans to enter and stay.",
    },
    weather: {
      summary: "Hot, humid, and green every single month. There is no winter — only 'rainy' and 'less rainy'.",
      seasons: [
        { period: "Year-round", detail: "77–90°F, humidity 80%+. Afternoon thunderstorms are normal." },
        { period: "Nov – Feb", detail: "Northeast monsoon — heavier rain on the east coast, flooding possible." },
        { period: "May – Sep", detail: "Drier window, best for moving and settling in." },
      ],
    },
    cities: [
      { name: "Kuala Lumpur (Bangi & Shah Alam)", note: "Huge English-speaking Muslim community, international Islamic schools, masjids on every corner." },
      { name: "Putrajaya / Cyberjaya", note: "Planned, clean, calm — popular with expat families and students of knowledge." },
      { name: "Penang", note: "Island life, legendary halal food scene, slower pace, strong heritage Muslim community." },
      { name: "Johor Bahru", note: "Cheaper living with Singapore's economy next door." },
    ],
    languages: "Malay (Bahasa Malaysia) is official, but English is genuinely usable — schools, hospitals, government offices and groceries all work in English. Arabic is common in Islamic school circles.",
    transport: "KL has clean, cheap MRT/LRT/monorail lines. Grab (ride-hailing) is everywhere and costs a few dollars per ride. Most families eventually buy a car — fuel is subsidized and driving is on the left.",
    food: "A halal paradise. JAKIM certification is strict and trusted. Every cuisine from Malay to Yemeni to Korean is available halal. Western groceries (Cheerios, Philly cream cheese) at Jaya Grocer, Village Grocer, and Ben's — at import prices.",
    costOfLiving: {
      rent: "$500–$1,100 (3-bed condo with pool & gym)",
      groceries: "$350–$550 / month",
      schooling: "$250–$900 / month per child (international Islamic schools)",
      utilities: "$80–$150 (heavy A/C use)",
      total: "$1,500–$2,600 / month for a family of four",
    },
    rentals: {
      tourist: "Airbnb and serviced apartments, no lease possible — fine for a 1–3 month scouting trip.",
      nomad: "Standard 12-month leases open up; landlords want 2+1 month deposit (2 months security + 1 month advance).",
      student: "Same lease access; many families rent near their school or university campus.",
      residency: "Full access to leases and even property purchase above state minimums (~RM 1M in KL for foreigners).",
    },
    mom: {
      rating: 4.5,
      scores: { safety: 5, community: 5, cost: 4, bureaucracy: 4 },
      verdict: "If I had to send one sister blindfolded to start her hijrah tomorrow, it would be Malaysia — the softest landing you can find. English works, the masjids are full, the food is halal by default, and your dollar stretches. The humidity and the paperwork for long-term stays are the tax you pay — and honestly, it's worth it.",
      pros: ["Halal is the default, not the exception", "English gets you through 90% of life", "Large American & British Muslim expat sisterhood", "Excellent international Islamic schools", "90-day visa-free entry to scout"],
      cons: ["Relentless humidity", "Long-term residency is expensive or bureaucratic", "Traffic in KL is real", "Imported American groceries cost double"],
    },
  },
  {
    slug: "uae",
    name: "UAE",
    arabic: "الإمارات",
    flag: "🇦🇪",
    capital: "Abu Dhabi",
    region: "Middle East",
    coords: [54.4, 24.4],
    tagline: "The easiest landing — at a premium price",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxkdWJhaSUyMHNreWxpbmV8ZW58MHx8fDE3ODg3OTQ0ODF8MA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Dubai skyline at dusk, United Arab Emirates",
    quickFacts: {
      currency: "UAE Dirham (AED), pegged 3.67/USD",
      timezone: "GMT+4",
      language: "Arabic + near-universal English",
      muslimPercent: "~76% (citizens & residents)",
      flightTime: "~13 hrs from NYC",
      climate: "Desert; 75°F winters, 110°F+ summers",
    },
    visa: {
      tourist: "US citizens receive a free 90-day visa on arrival — no fee, no paperwork. Plenty of runway to scout schools and neighborhoods.",
      longStay: "The one-year Remote Work Visa (~$287 + insurance, requires ~$3,500/mo income proof) is the go-to for remote-working families. Golden Visas (5–10 yrs) require property or significant income.",
      student: "Student residence visas sponsored by universities; parents can be sponsored by a working spouse or their own remote work visa.",
      work: "Employment residence visas are employer-sponsored and very streamlined — many sisters arrive via a spouse's job.",
      summary: "The most streamlined visa machinery in the Muslim world. Everything is an app.",
    },
    weather: {
      summary: "Two seasons: beautiful (Nov–Mar) and survival mode (May–Sep).",
      seasons: [
        { period: "Nov – Mar", detail: "68–85°F, outdoor park and beach season — glorious." },
        { period: "Apr – May & Oct", detail: "Warming shoulder months, 90–100°F." },
        { period: "Jun – Sep", detail: "105–118°F with humidity on the coast. Life moves indoors to A/C." },
      ],
    },
    cities: [
      { name: "Dubai (Mirdif, Al Barsha, International City)", note: "Biggest expat Muslim infrastructure — English khutbahs, Islamic schools, halal everything." },
      { name: "Abu Dhabi (Khalifa City)", note: "Calmer, more family-oriented, excellent schools." },
      { name: "Sharjah", note: "Cheaper rents, more conservative atmosphere, dry emirate — many practicing families prefer it." },
      { name: "Ajman & Ras Al Khaimah", note: "Budget-friendly northern emirates with growing communities." },
    ],
    languages: "Arabic is official, but English is the lingua franca — signage, hospitals, schools and government apps all run in English. You can live years here with minimal Arabic, for better or worse.",
    transport: "Dubai Metro and trams are spotless and cheap, with women-and-children cabins. Taxis and Careem/Uber are abundant. Most families drive — fuel is cheap, parking is everywhere, and summer makes walking impossible.",
    food: "Halal is universal. Every American chain exists (Chipotle-style, Shake Shack, Cheesecake Factory) in halal form. Waitrose, Spinneys and Carrefour stock full Western grocery aisles, including a pork room kept separate for non-Muslims.",
    costOfLiving: {
      rent: "$1,400–$2,800 (2–3 bed apartment; Sharjah ~40% less)",
      groceries: "$500–$800 / month",
      schooling: "$400–$1,400 / month per child (wide range of Islamic & international schools)",
      utilities: "$150–$300 (A/C-heavy summers)",
      total: "$3,000–$5,000 / month for a family of four",
    },
    rentals: {
      tourist: "Hotel apartments and Airbnb only — you cannot sign a lease without an Emirates ID.",
      nomad: "With a remote work visa + Emirates ID you can sign standard 1-year leases (Ejari-registered in Dubai). Expect 1–4 rent cheques per year.",
      student: "Same lease access once residence is issued; many families cluster near school zones.",
      residency: "Full access; foreigners can also buy freehold property in designated zones (path to Golden Visa at AED 2M+).",
    },
    mom: {
      rating: 4,
      scores: { safety: 5, community: 4, cost: 2, bureaucracy: 5 },
      verdict: "The UAE is the training wheels of hijrah — you will never feel unsafe, everything works, and your kids' Islamic school options are world-class. But it is a gilded landing pad, not a forever home for most of us: the rent will humble you, and the dunya glitter is a real test. Come with a plan and a budget, not a vibe.",
      pros: ["Safest country on this list, full stop", "Everything is digitized — visas, bills, IDs", "Massive English-speaking Muslim community", "World-class Islamic and international schools", "Direct flights home to the US"],
      cons: ["Most expensive option on this list", "Summer heat is genuinely extreme", "Transient expat culture — friends leave", "No path to citizenship; you're always a guest"],
    },
  },
  {
    slug: "egypt",
    name: "Egypt",
    arabic: "مصر",
    flag: "🇪🇬",
    capital: "Cairo",
    region: "Africa",
    coords: [31.2, 30.0],
    tagline: "The heartland — maximum deen per dollar",
    image: "https://images.unsplash.com/photo-1503177119275-0aa32b3a9368?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxlZ3lwdCUyMHB5cmFtaWRzfGVufDB8fHx8MTc4ODcwODQ2NHww&ixlib=rb-4.1.0&q=85",
    imageAlt: "The pyramids of Giza outside Cairo, Egypt",
    quickFacts: {
      currency: "Egyptian Pound (EGP)",
      timezone: "GMT+2",
      language: "Egyptian Arabic; limited English",
      muslimPercent: "~90%",
      flightTime: "~11 hrs from NYC",
      climate: "Hot dry summers, mild winters",
    },
    visa: {
      tourist: "US citizens get a 30-day visa on arrival ($30, cash USD) or an e-visa in advance. Extensions at the Mogamma-style passport offices are a rite of passage.",
      longStay: "Long-term residency is typically via property purchase, proof of income, or study. Many Western families live on rolling tourist renewals or 1–5 year 'non-tourist' residencies arranged through local agents.",
      student: "A huge draw: Al-Azhar University and countless Quran/Arabic institutes sponsor student visas, and students can sponsor dependents.",
      work: "Work permits exist but wages are local; nearly all American moms here live on US remote income or savings.",
      summary: "Cheap and doable, but bureaucracy is analog and patience-testing.",
    },
    weather: {
      summary: "Sunshine almost every day of the year. Cairo is dry heat; Alexandria is breezier and humid.",
      seasons: [
        { period: "Jun – Sep", detail: "90–100°F in Cairo, dry. Upper Egypt (Luxor, Aswan) far hotter." },
        { period: "Oct – Apr", detail: "60–80°F, perfect weather; winter evenings need a light jacket." },
        { period: "Mar – May", detail: "Khamsin season — occasional hot dusty windstorms." },
      ],
    },
    cities: [
      { name: "Cairo – Nasr City & Madinaty", note: "Where the Western Muslim expat community actually lives — Quran schools, sisters' circles, American-style compounds." },
      { name: "New Cairo / Rehab", note: "Gated communities, international schools, malls — the softest Cairo landing." },
      { name: "Alexandria", note: "Mediterranean breeze, cheaper rents, slower pace, big student community." },
      { name: "Mansoura & Tanta", note: "Deep-immersion Arabic/Quran study towns for the serious student of knowledge." },
    ],
    languages: "Egyptian Arabic dominates daily life. English works in international schools, private hospitals and expat compounds — but landlords, taxis and bureaucracy run on Arabic. Budget time for language classes.",
    transport: "Cairo's metro is cheap, crowded, and has women's cars. Uber and Careem are everywhere and astonishingly cheap (cross-town rides for $2–4). Driving yourself is an extreme sport — most expat families rely on ride-hailing.",
    food: "Halal by default; you will never scan an ingredients label again. Local produce is fresh, seasonal and incredibly cheap. American imports exist at Gourmet and Seoudi supermarkets — at 2–3x US prices.",
    costOfLiving: {
      rent: "$250–$600 (3-bed in Nasr City / New Cairo)",
      groceries: "$250–$400 / month",
      schooling: "$100–$500 / month per child (private Arabic/English or international)",
      utilities: "$30–$70",
      total: "$900–$1,600 / month for a family of four",
    },
    rentals: {
      tourist: "Furnished short-term flats are common in expat areas; cash deals via Facebook groups and brokers.",
      nomad: "12-month furnished leases are the norm; expect to pay several months upfront and negotiate hard.",
      student: "Student visa holders easily sign leases; landlords love foreign students who pay in USD.",
      residency: "Full lease access; foreigners can buy property (registration is slow — use a lawyer).",
    },
    mom: {
      rating: 3.5,
      scores: { safety: 3, community: 5, cost: 5, bureaucracy: 2 },
      verdict: "Egypt is where your money becomes sadaqah to your future self — Quran teachers for $3 an hour, rent under $400, and a Muslim majority so complete that the adhan still stops traffic. But come eyes open: the bureaucracy is a patience exam, the traffic is lawless, and you need Arabic or a good fixer. For students of knowledge and families on a tight budget, nothing beats it.",
      pros: ["Cheapest quality Muslim life on this list", "Unmatched Quran & Arabic study scene", "Deep, warm, genuinely practicing community", "Your US income goes 3x further", "Kids grow up hearing the adhan five times a day"],
      cons: ["Bureaucracy is exhausting and analog", "Traffic and street harassment are real", "Air pollution in Cairo", "English alone won't carry you"],
    },
  },
  {
    slug: "morocco",
    name: "Morocco",
    arabic: "المغرب",
    flag: "🇲🇦",
    capital: "Rabat",
    region: "Africa",
    coords: [-6.8, 34.0],
    tagline: "Andalusi soul, Mediterranean ease",
    image: "https://images.unsplash.com/photo-1564507004663-b6dfb3c824d5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxtb3JvY2NvJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4ODcwODQ2NHww&ixlib=rb-4.1.0&q=85",
    imageAlt: "Blue-washed courtyard in Chefchaouen, Morocco",
    quickFacts: {
      currency: "Moroccan Dirham (MAD)",
      timezone: "GMT+1",
      language: "Darija + French; growing English",
      muslimPercent: "~99%",
      flightTime: "~7 hrs from NYC",
      climate: "Mediterranean coast, hot inland",
    },
    visa: {
      tourist: "US citizens enter visa-free for 90 days. Border runs to Ceuta or Spain are the classic renewal hack.",
      longStay: "Residency (carte de séjour) is applied for at the local police prefecture within 90 days — proof of income/savings (~$1,000+/mo helps), a lease, and a police clearance. Renewable yearly.",
      student: "Student residency via enrollment in universities or Arabic/Quran institutes; the famous Qarawiyyin tradition lives in Fes.",
      work: "Work permits are employer-sponsored; realistically most American moms use residency-by-means or a spouse's permit.",
      summary: "Visa-free entry is generous; converting to residency takes paperwork and patience.",
    },
    weather: {
      summary: "The most temperate climate on this list — real seasons, ocean air, no extreme humidity.",
      seasons: [
        { period: "Coastal (Rabat, Casa, Tangier)", detail: "60–80°F most of the year; mild wet winters, dry breezy summers." },
        { period: "Inland (Marrakech, Fes)", detail: "Hot dry summers 95–105°F, crisp winters down to the 40s." },
        { period: "Mountains & Desert", detail: "Snow in the Atlas in winter; Sahara is for visits, not living." },
      ],
    },
    cities: [
      { name: "Rabat", note: "The calm, clean capital — best schools, embassies, and a growing anglophone Muslim community." },
      { name: "Casablanca", note: "The economic engine; big-city Muslim life with the Hassan II Mosque as its heart." },
      { name: "Tangier", note: "Northern port city, close to Spain, mild weather, cheaper than the capital." },
      { name: "Marrakech", note: "Beautiful and spiritual but tourist-saturated; great for visits, mixed for raising kids." },
    ],
    languages: "Moroccan Arabic (Darija) is the street language — and it's famously different from the Arabic you studied. French runs the schools, hospitals and bureaucracy. English is growing fast among youth but don't rely on it yet.",
    transport: "ONCF trains connect the coast and are excellent — including Africa's first high-speed line (Tangier–Casablanca). Petit taxis are cheap for in-town hops. Driving is manageable by regional standards; highways are modern toll roads.",
    food: "Everything is halal; Morocco is ~99% Muslim. The local cuisine (tagine, couscous, msemen) is a gift. French supermarkets (Carrefour, Marjane) carry familiar Western goods; American-specific brands are rarer and pricier.",
    costOfLiving: {
      rent: "$400–$900 (3-bed apartment in a good neighborhood)",
      groceries: "$300–$450 / month",
      schooling: "$150–$700 / month per child (French or American-curriculum schools)",
      utilities: "$50–$100",
      total: "$1,300–$2,200 / month for a family of four",
    },
    rentals: {
      tourist: "Furnished riads and Airbnb apartments for scouting trips; long leases technically require residency.",
      nomad: "No formal nomad visa — sign a lease as part of your residency application (you need the lease to get residency, and vice versa; agents help square the circle).",
      student: "Student residents sign standard 1-year leases; deposits of 1–2 months are typical.",
      residency: "Full access; foreigners can buy apartments and titled land freely.",
    },
    mom: {
      rating: 4,
      scores: { safety: 4, community: 4, cost: 4, bureaucracy: 3 },
      verdict: "Morocco stole a piece of my heart — praying where the adhan has echoed for twelve centuries, ocean sunsets after iftar, children who say salam before hello. The honest caveat: it's Darija and French, not English, and the school system rewards families who commit to French. If you're willing to become a little Moroccan, it will love you back.",
      pros: ["Deep, living Islamic heritage everywhere", "Best weather on this list", "Visa-free 90 days to scout", "Affordable coastal living", "Short flight back to the US East Coast"],
      cons: ["Darija is a steep learning curve", "French-language school system", "Residency paperwork is slow", "Smaller anglophone Muslim community than Malaysia or UAE"],
    },
  },
  {
    slug: "indonesia",
    name: "Indonesia",
    arabic: "إندونيسيا",
    flag: "🇮🇩",
    capital: "Jakarta",
    region: "Asia",
    coords: [106.8, -6.2],
    tagline: "The world's largest Muslim nation, island by island",
    image: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxpbmRvbmVzaWElMjBiYWxpfGVufDB8fHx8MTc4ODcwODQ2NHww&ixlib=rb-4.1.0&q=85",
    imageAlt: "Lush tropical landscape in Indonesia",
    quickFacts: {
      currency: "Indonesian Rupiah (IDR)",
      timezone: "GMT+7 to +9",
      language: "Bahasa Indonesia; patchy English",
      muslimPercent: "~87% (largest Muslim population on earth)",
      flightTime: "~22 hrs from NYC",
      climate: "Tropical, 78–90°F year-round",
    },
    visa: {
      tourist: "US citizens get a 30-day Visa on Arrival (~$35), extendable once for 30 more days. The B211A visit visa allows 60 days, extendable to 180.",
      longStay: "KITAS temporary residence permits come via work, marriage to an Indonesian, retirement (55+), or the newer Second Home Visa (requires proof of ~$130k in funds or property).",
      student: "Student KITAS via universities and Islamic boarding schools (pesantren) — a serious option for families seeking immersion.",
      work: "Work KITAS is employer-sponsored with government quotas; most American moms use visit visas, spouse sponsorship, or remote income.",
      summary: "Easy to visit, genuinely hard to stay long-term without marriage, work, or capital.",
    },
    weather: {
      summary: "Equatorial and consistent: warm, humid, green. Seasons are 'wet' and 'dry'.",
      seasons: [
        { period: "Apr – Oct (Dry)", detail: "78–90°F, sunnier, best time to move and explore." },
        { period: "Nov – Mar (Wet)", detail: "Daily downpours, higher humidity, occasional flooding in Jakarta." },
        { period: "Year-round", detail: "Sunrise ~5:45am, sunset ~6pm, every day, forever. Beautiful routine." },
      ],
    },
    cities: [
      { name: "Jakarta (South Jakarta, Depok)", note: "Massive city, massive ummah — international Islamic schools, expat sisters' circles, endless masjids." },
      { name: "Bandung", note: "Cooler highland air, university town, beloved by young families." },
      { name: "Yogyakarta", note: "The spiritual student city — affordable, artistic, deeply Muslim, home to famous Islamic universities." },
      { name: "Bali (note)", note: "Beautiful but Hindu-majority with a party-tourism scene — wonderful to visit, not where I'd raise Muslim children." },
    ],
    languages: "Bahasa Indonesia is refreshingly learnable (Latin alphabet, no verb conjugations) and is essential outside expat bubbles. English works in international schools and Jakarta business districts, less so at the market or the clinic.",
    transport: "Gojek and Grab motorbike taxis are the lifeblood — $1 rides across town. Jakarta has a new MRT and decent commuter trains. Traffic is legendary; families often live walking-distance from school and masjid on purpose.",
    food: "The world's largest halal food ecosystem — street satay to fine dining, all halal (MUI/BPJPH certified). Western groceries at Ranch Market, Grand Lucky, and Kem Chicks at import prices. Local tropical fruit is absurdly good and cheap.",
    costOfLiving: {
      rent: "$350–$900 (3-bed house or apartment)",
      groceries: "$250–$450 / month",
      schooling: "$150–$800 / month per child (Islamic international schools)",
      utilities: "$60–$120",
      total: "$1,100–$2,000 / month for a family of four",
    },
    rentals: {
      tourist: "Monthly villas and guesthouses are easy; formal leases generally need a KITAS.",
      nomad: "No true nomad visa yet — long-stayers use B211A chains or remote-worker KITAS via local sponsors.",
      student: "Student KITAS holders can sign 1–2 year leases; houses often require 1 year upfront in cash.",
      residency: "KITAS/KITAP holders lease freely; foreigners can hold long leasehold (hak pakai) property, not freehold.",
    },
    mom: {
      rating: 4,
      scores: { safety: 4, community: 5, cost: 4, bureaucracy: 3 },
      verdict: "Indonesia is the gentlest Islam I've ever met — smiling, generous, woven into daily life — and Yogyakarta might be the best-value Islamic education hub on earth. The visa wall is the honest problem: without marriage, a job, or serious savings, you're a long-term tourist. Come for a season of study and see if Allah opens a door.",
      pros: ["Largest, warmest Muslim community on earth", "Bahasa is genuinely learnable", "Incredible value for money", "World-class affordable Islamic schooling", "Nature that makes dhikr easy"],
      cons: ["Long-term visas are hard for singles and remote workers", "Jakarta traffic and air quality", "Earthquake and flood awareness needed", "Far from the US — 22+ hours of travel"],
    },
  },
  {
    slug: "saudi",
    name: "Saudi Arabia",
    arabic: "السعودية",
    flag: "🇸🇦",
    capital: "Riyadh",
    region: "Middle East",
    coords: [46.7, 24.6],
    tagline: "The land of the Haramain",
    image: "https://images.unsplash.com/photo-1579305796153-ab71ce202953?fm=jpg&q=60&w=1200&auto=format&fit=crop",
    imageAlt: "The Kaaba in Makkah, Saudi Arabia",
    quickFacts: {
      currency: "Saudi Riyal (SAR), pegged 3.75/USD",
      timezone: "GMT+3",
      language: "Arabic; English in business & compounds",
      muslimPercent: "~93% of residents",
      flightTime: "~12.5 hrs from NYC",
      climate: "Desert; mild winters, 110°F+ summers",
    },
    visa: {
      tourist: "US citizens can get the tourist eVisa online in minutes (~SAR 535 / $142, includes health insurance): multiple entry, valid 1 year, up to 90 days per visit. A 5-year multiple-entry visit visa also exists for US passport holders (up to 180 days per stay, covers Umrah outside Hajj season) — but it is a sticker visa that only certain embassies will issue, so you may need to use a licensed visa agency to obtain it.",
      longStay: "There is no digital nomad visa. Long-term routes are: employment (Iqama residence via employer), Premium Residency (~$26,000/year or ~$213,000 one-time), or study scholarships.",
      student: "Serious option: scholarships at the Islamic University of Madinah, Umm al-Qura (Makkah) and Imam Mohammad Ibn Saud (Riyadh) include residency, a stipend, and sometimes family support.",
      work: "The realistic door for most families — a spouse's employment contract brings the whole family on dependent Iqamas, often with housing and school allowances.",
      summary: "Easy to visit, and life near the Haramain is priceless — but staying requires a job, a scholarship, or serious capital.",
    },
    weather: {
      summary: "Desert continental: winters are genuinely lovely, summers are survival-by-air-conditioning.",
      seasons: [
        { period: "Nov – Mar", detail: "60–85°F, cool desert evenings — the season everyone loves." },
        { period: "Apr – May & Oct", detail: "Warming fast, 95–105°F afternoons." },
        { period: "Jun – Sep", detail: "110–120°F inland (Riyadh); Jeddah adds crushing coastal humidity." },
      ],
    },
    cities: [
      { name: "Madinah", note: "The city of the Prophet ﷺ — calm, safe, family-centered; the dream for many, reachable via student or work routes." },
      { name: "Jeddah", note: "Historic, open, coastal — the traditional expat gateway with big international school options." },
      { name: "Riyadh", note: "The booming capital — most jobs, most opportunity, fastest-changing city in the region." },
      { name: "Makkah", note: "Entry is restricted to Muslims only. Living here is usually tied to study or work sponsorship." },
    ],
    languages: "Arabic is the language of life, government and school. English is common in international companies, compounds and big-city hospitals, but you'll want real Arabic — and where better on earth to learn it?",
    transport: "The Haramain high-speed train links Makkah–Jeddah–Madinah beautifully. Riyadh opened its massive new metro in 2024. Uber and Careem are everywhere, women have driven since 2018, and fuel is cheap — most families own a car.",
    food: "100% halal by law — no pork, no alcohol, anywhere. Kabsa and mandi are staples; every American chain exists in halal form. Western groceries at Danube, Tamimi and Carrefour at import prices.",
    costOfLiving: {
      rent: "$800–$2,000 (3-bed; compounds cost more, local neighborhoods less)",
      groceries: "$400–$600 / month",
      schooling: "$300–$1,500 / month per child (international schools vary hugely)",
      utilities: "$100–$200 (summer A/C)",
      total: "$2,200–$4,000 / month for a family of four",
    },
    rentals: {
      tourist: "Hotel apartments and furnished units only — formal leases require an Iqama (residence ID).",
      nomad: "No nomad visa exists; long stays without work/study sponsorship aren't practical.",
      student: "Scholarship students receive housing or a housing allowance; family housing near universities is affordable.",
      residency: "With an Iqama you sign Ejar-registered leases (1 year, often paid semi-annually upfront). Expat compounds offer Western-style living at a premium.",
    },
    mom: {
      rating: 3.5,
      scores: { safety: 5, community: 4, cost: 3, bureaucracy: 2 },
      verdict: "Living near the Haramain is a spiritual experience nothing else on this list can touch — hearing 'hayya alas-salah' and actually answering it, every single day. But be honest with yourself: there is no easy visa, bureaucracy runs on wasta and patience, and the summer is a furnace. If Allah opens a door here — a job, a scholarship — take it. If not, visit for umrah and let the longing do its work.",
      pros: ["Praying in the Two Haramain as your local masjids", "Extremely safe, family-first society", "100% halal everything, zero checking labels", "Tax-free salaries with family benefits", "Scholarship route for serious students"],
      cons: ["No easy long-term visa for independent families", "Extreme summer heat", "Bureaucracy can be opaque and slow", "Less personal freedom than any other country on this list"],
    },
  },
  {
    slug: "turkiye",
    name: "Turkey",
    arabic: "تركيا",
    flag: "🇹🇷",
    capital: "Ankara",
    region: "Asia",
    coords: [28.9, 41.0],
    tagline: "Ottoman beauty with a four-season soul",
    image: "https://images.unsplash.com/photo-1545069128-193f82499904?fm=jpg&q=60&w=1200&auto=format&fit=crop",
    imageAlt: "The Blue Mosque by the Bosphorus in Istanbul, Turkey",
    quickFacts: {
      currency: "Turkish Lira (TRY)",
      timezone: "GMT+3",
      language: "Turkish; limited English outside hubs",
      muslimPercent: "~99%",
      flightTime: "~10 hrs from NYC",
      climate: "Four real seasons, snowy winters",
    },
    visa: {
      tourist: "US citizens enter visa-free for 90 days within any 180-day period. No fee, no paperwork — just land.",
      longStay: "The classic route: a short-term residence permit (ikamet) via a rental or property purchase, renewable yearly. Turkey's 2024 digital nomad visa (ages 21–55, ~$3,000/mo income) suits remote workers. Citizenship by investment starts at $400k in property.",
      student: "Student ikamet via universities or Turkish-language courses (TÖMER) — a popular, affordable bridge year.",
      work: "Work permits are employer-sponsored; many American moms live on remote income + ikamet instead.",
      summary: "One of the few Muslim countries with a genuinely workable renewable residency for ordinary families.",
    },
    weather: {
      summary: "The only four-season climate on this list: blossoms, beach summers, golden autumns, and real snow.",
      seasons: [
        { period: "Apr – Jun", detail: "60–80°F, tulips and Bosphorus evenings — Istanbul at its best." },
        { period: "Jul – Sep", detail: "80–95°F, humid in Istanbul; Aegean coast is drier." },
        { period: "Nov – Feb", detail: "35–50°F, gray, rainy, occasional snow — pack real coats." },
      ],
    },
    cities: [
      { name: "Istanbul (Üsküdar, Fatih, Başakşehir)", note: "The heart of it all — conservative family neighborhoods, historic masjids, huge Arabic-speaking Muslim community." },
      { name: "Bursa", note: "Green, Ottoman, calmer and cheaper — families rave about it." },
      { name: "Konya", note: "The city of Rumi — deeply spiritual, very affordable, slower life." },
      { name: "Ankara & Izmir", note: "Ankara is administrative and orderly; Izmir is coastal and secular-leaning." },
    ],
    languages: "Turkish runs daily life and bureaucracy — and it's learnable, with a Latin alphabet. English is thin outside tourist and business districts. A bonus for our community: large Arabic-speaking Syrian and Gulf communities mean Arabic works in many Muslim circles.",
    transport: "Istanbul's metro, tram, ferry and Metrobus network is excellent and dirt cheap with an Istanbulkart. Intercity buses are famously comfortable. Ride-hailing (BiTaksi/Uber) exists; driving in Istanbul traffic is a test of tawakkul.",
    food: "Halal is the default nationwide. Turkish cuisine is a gift — kebabs, pide, breakfast spreads, baklava. Western groceries and imported brands at Migros, Macrocenter and CarrefourSA; prices have risen with inflation.",
    costOfLiving: {
      rent: "$400–$900 (3-bed in family districts of Istanbul; less elsewhere)",
      groceries: "$300–$450 / month",
      schooling: "$200–$900 / month per child (international & private schools)",
      utilities: "$60–$120",
      total: "$1,400–$2,400 / month for a family of four",
    },
    rentals: {
      tourist: "Furnished Airbnb-style flats everywhere; 90 days visa-free makes scouting easy.",
      nomad: "Digital nomad visa or a short-term ikamet lets you sign notarized 1-year leases (some neighborhoods are closed to new foreign registrations — check before you sign).",
      student: "Student ikamet holders lease normally; expect 1–2 months deposit plus agent fee.",
      residency: "Full lease access; foreigners can buy property (which itself can anchor residency, $200k+ in big cities).",
    },
    mom: {
      rating: 4,
      scores: { safety: 4, community: 4, cost: 4, bureaucracy: 3 },
      homeTake: "A land full of history and friendly people — praying in masjids where sultans prayed, kids feeding seagulls on the Bosphorus ferry, simit and tea for a dollar. Two honest cautions: English is not widely spoken outside of tourist areas, and Istanbul has more of a liberal European vibe than an Islamic one.",
      verdict: "A land full of history and friendly people — praying in masjids where sultans prayed, kids feeding seagulls on the Bosphorus ferry, simit and tea for a dollar. The honest cautions: English is not widely spoken outside of tourist areas, Istanbul has more of a liberal European vibe than an Islamic one, inflation moves prices monthly, and residency rules tighten without warning. Come with savings in dollars, patience, and a Turkish course.",
      pros: ["Renewable residency normal families can actually get", "Four seasons and breathtaking beauty", "Deep Islamic heritage everywhere you look", "Excellent, affordable healthcare", "Huge Muslim expat community from everywhere"],
      cons: ["Inflation and currency swings", "Turkish is essential and takes real work", "Residency rules change frequently", "Istanbul traffic and crowds"],
    },
  },
  {
    slug: "qatar",
    name: "Qatar",
    arabic: "قطر",
    flag: "🇶🇦",
    capital: "Doha",
    region: "Middle East",
    coords: [51.5, 25.3],
    tagline: "Small, rich, and quietly family-focused",
    image: "https://images.unsplash.com/photo-1584957292742-10a90a507d91?fm=jpg&q=60&w=1200&auto=format&fit=crop",
    imageAlt: "The Doha skyline in Qatar",
    quickFacts: {
      currency: "Qatari Riyal (QAR), pegged 3.64/USD",
      timezone: "GMT+3",
      language: "Arabic + wide English",
      muslimPercent: "~66% of residents",
      flightTime: "~12.5 hrs from NYC",
      climate: "Desert; lovely winters, fierce summers",
    },
    visa: {
      tourist: "US citizens get a free visa waiver on arrival: 30 days, extendable once for 30 more. One of the easiest entries in the Gulf.",
      longStay: "Residency runs through employer sponsorship (work visa → QID), family sponsorship if a spouse works there, or property ownership ($200k+ grants temporary residency; $730k+ grants permanent-resident benefits). No nomad visa.",
      student: "Student visas via universities (Education City hosts US campuses like Georgetown and Northwestern) — a niche but real route.",
      work: "The standard path: a job offer brings the whole family. Teaching, healthcare, energy and finance are the big expat sectors.",
      summary: "Effortless to visit; staying means a job, a working spouse, or buying property.",
    },
    weather: {
      summary: "Like the UAE: a perfect winter and a summer you experience mostly through car windows.",
      seasons: [
        { period: "Nov – Mar", detail: "65–85°F, beach and park season — Doha sparkles." },
        { period: "Apr – May & Oct", detail: "90–105°F shoulder months." },
        { period: "Jun – Sep", detail: "105–118°F; life moves to malls, museums and A/C." },
      ],
    },
    cities: [
      { name: "Doha (Al Sadd, Al Waab, West Bay)", note: "Where most families live — schools, malls, masjids, metro all close." },
      { name: "The Pearl-Qatar", note: "Polished island living; beautiful but pricey and less neighborhood-y." },
      { name: "Al Wakrah", note: "Quieter, cheaper, souq-by-the-sea charm — growing with young families." },
      { name: "Education City area", note: "Calm, green, academic bubble around the universities." },
    ],
    languages: "Arabic is official; English is everywhere in daily life — schools, clinics, shops, government apps. One of the easiest Muslim countries to function in without Arabic.",
    transport: "The Doha Metro is spotless, cheap and family-friendly. Karwa taxis and Uber are plentiful. Most families still drive — fuel is cheap and summer makes walking a no.",
    food: "Halal is universal. Everything is imported and available: full Western grocery aisles at Al Meera, Carrefour and Monoprix. Dining out ranges from shawarma stands to Michelin-adjacent.",
    costOfLiving: {
      rent: "$1,400–$2,500 (2–3 bed apartment or compound villa share)",
      groceries: "$500–$750 / month",
      schooling: "$400–$1,300 / month per child",
      utilities: "$80–$200",
      total: "$3,000–$4,800 / month for a family of four",
    },
    rentals: {
      tourist: "Hotel apartments only — leases require a QID residence permit.",
      nomad: "No nomad visa; long independent stays aren't practical.",
      student: "Student visa holders can lease with university support letters; many live in campus-linked housing.",
      residency: "With a QID you sign standard 1-year leases (post-dated cheques still common). Property purchase of $200k+ comes with residency rights.",
    },
    mom: {
      rating: 3.5,
      scores: { safety: 5, community: 3, cost: 2, bureaucracy: 4 },
      verdict: "Qatar is the calmest, cleanest, safest option in the Gulf — Fridays at the masjid, museums for the kids, zero stress about crime. My honest reservation: it's a company town. Without a strong job package the math hurts, the community is smaller than Dubai's, and everyone you love is one contract away from leaving. Wonderful with a good salary; hard without one.",
      pros: ["Top-tier safety and cleanliness", "Family sponsorship is straightforward with a job", "Great Islamic institutions (QF, Fanar) and libraries", "Direct flights to the US (Qsuite!)", "Compact — everything is 20 minutes away"],
      cons: ["Expensive without an employment package", "No nomad or independent residency route", "Small expat Muslim community vs UAE", "Summer heat and limited outdoor life half the year"],
    },
  },
  {
    slug: "tanzania",
    name: "Tanzania",
    arabic: "تنزانيا",
    flag: "🇹🇿",
    capital: "Dodoma (Dar es Salaam is the hub)",
    region: "Africa",
    coords: [39.2, -6.3],
    tagline: "Swahili coast serenity and the spice island of Zanzibar",
    image: "https://images.unsplash.com/photo-1627899316397-3556313abd3d?fm=jpg&q=60&w=1200&auto=format&fit=crop",
    imageAlt: "A traditional dhow sailboat at sunset off Zanzibar, Tanzania",
    quickFacts: {
      currency: "Tanzanian Shilling (TZS)",
      timezone: "GMT+3",
      language: "Swahili + English (both official)",
      muslimPercent: "~35% nationwide; ~99% in Zanzibar",
      flightTime: "~17 hrs from NYC (1 stop)",
      climate: "Tropical coast, 75–90°F",
    },
    visa: {
      tourist: "US citizens need a visa — but it's easy: the eVisa online or visa on arrival, $100 for a 12-month multiple-entry visa (Americans get the multiple-entry by default), 90 days per stay.",
      longStay: "Residence permits are Class B (work) or Class A (investor/business). Many long-stayers also base in Zanzibar, which runs its own friendly immigration desk alongside the mainland system.",
      student: "Student passes via universities and the many Quran/Arabic madrasas in Zanzibar and Dar es Salaam — an affordable immersion route.",
      work: "Work permits are employer-sponsored (NGOs, schools, tourism). Remote income + repeated 90-day stays is the common informal pattern.",
      summary: "A $100 visa buys Americans a whole year of multiple entries — the most generous door in East Africa.",
    },
    weather: {
      summary: "Tropical coast: warm, breezy, and humid, with two rainy seasons. Zanzibar is beach weather almost all year.",
      seasons: [
        { period: "Jun – Oct (Dry)", detail: "75–85°F, breezy, the best months to move and explore." },
        { period: "Nov – Dec", detail: "'Short rains' — brief afternoon showers." },
        { period: "Mar – May (Long rains)", detail: "Heavy downpours and high humidity; island life slows down." },
      ],
    },
    cities: [
      { name: "Zanzibar (Stone Town)", note: "99% Muslim, UNESCO-listed coral-stone alleys, the adhan everywhere — the spiritual heart of the coast." },
      { name: "Zanzibar (Nungwi, Paje)", note: "Beach villages with growing expat families, kite-surfing, and simple island living." },
      { name: "Dar es Salaam (Masaki, Upanga)", note: "The big-city gateway — huge coastal Muslim community, international schools, modern amenities." },
      { name: "Tanga", note: "Sleepy, historic, very Muslim northern coastal town for slow-living families." },
    ],
    languages: "Swahili is the soul of daily life — and it's famously learnable, written in Latin letters with Arabic roots everywhere (you already know more than you think: safari, simba, salama). English is official and works in schools, hospitals, and business.",
    transport: "Dala dala minibuses and boda boda motorbike taxis run the towns; Bajaj tuk-tuks are the family favorite. Fast ferries link Dar es Salaam and Zanzibar in ~2 hours. Most expat families in Dar eventually get a car; on Zanzibar, life is slower and smaller.",
    food: "On the coast and in Zanzibar, halal is the default — Swahili seafood, biryani, and urojo soup under the palm trees. Inland and in mixed cities, look for halal signs (they're common). Imported groceries at Shoppers and Village Supermarket in Dar.",
    costOfLiving: {
      rent: "$300–$800 (3-bed house or apartment; Zanzibar beachside higher)",
      groceries: "$250–$400 / month",
      schooling: "$150–$600 / month per child (international & Islamic schools in Dar/Zanzibar)",
      utilities: "$60–$120",
      total: "$1,000–$1,800 / month for a family of four",
    },
    rentals: {
      tourist: "Furnished apartments and guesthouses are everywhere; monthly deals are easy to negotiate in person.",
      nomad: "No formal nomad visa — long-stayers renew the multiple-entry visa or arrange residence through local sponsors.",
      student: "Student pass holders rent freely; Zanzibar landlords commonly offer 6–12 month furnished leases, cash.",
      residency: "Residence permit holders sign standard leases (often 6–12 months upfront outside Dar's expat zones). Foreigners cannot own land outright — long leases and local partnerships are the norm.",
    },
    mom: {
      rating: 3.5,
      scores: { safety: 4, community: 4, cost: 5, bureaucracy: 3 },
      verdict: "Tanzania is my wildcard pick and I mean that with love: praying in a 900-year-old masjid in Stone Town, kids learning Swahili from the neighbors, dhows at sunset after Maghrib — it is a soft, salty, unhurried life. Be honest about the trade-offs: mainland Tanzania is majority non-Muslim (you'll want the coast or Zanzibar), healthcare and schools are a step below Malaysia or the Gulf, and power cuts happen. For adventurous families on a budget, it's magic.",
      pros: ["$100 gets Americans a year of multiple entries", "Zanzibar is ~99% Muslim with deep Swahili-Islamic heritage", "Very affordable coastal living", "Swahili is easy and beautiful to learn", "Island life children never forget"],
      cons: ["Muslim community concentrated on the coast/islands", "Healthcare and schools below Gulf/Malaysia standard", "Power and water outages are part of life", "Far from the US — long, pricey flights"],
    },
  },
];

export const muslimMajorityNames = [
  "Saudi Arabia", "Turkey", "Qatar", "Oman", "Jordan", "Kuwait", "Bahrain",
  "Pakistan", "Bangladesh", "Iran", "Iraq", "Yemen", "Syria", "Lebanon",
  "Palestine", "Algeria", "Tunisia", "Libya", "Sudan", "Somalia",
  "Mauritania", "Mali", "Niger", "Chad", "Senegal", "Gambia", "Guinea",
  "Afghanistan", "Uzbekistan", "Turkmenistan", "Kazakhstan", "Kyrgyzstan",
  "Tajikistan", "Azerbaijan", "Albania", "Kosovo", "Brunei", "Maldives",
  "Comoros", "Djibouti", "Burkina Faso", "Western Sahara",
  "Egypt", "Morocco", "Malaysia", "Indonesia", "United Arab Emirates",
];

export const getCountry = (slug) => countries.find((c) => c.slug === slug);
